export default {
  mainColor: 'Hauptfarbe',
  secondaryColor: 'Sekundärfarbe',
  avatar: 'Avatar',
  avatarSize: 'Avatar-Größe',
  avatarShape: 'Avatarform',
  fontFamily: 'Schriftfamilie',
  fontSize: 'Schriftgröße',
  jobSeparator: 'Job-Trennzeichen'
};
